import React, { useState } from "react"
import PropTypes from "prop-types"
import styles from "./SignUpApplyWrapper.module.scss"
import SignUpApplyContainer from "./SignUpApplyWrapper"
import SignUpApplyStep2Form from "../../forms/SignUpApplyForms/SignUpApplyStep2Form"
import { useLocation } from "react-router-dom"

const SignUpApplyStep2Container = ({
  history,
  handleNext,
  handleBack,
  handleSaveApplyUser,
  step1Data,
  initialValues = {},
  isEditMode = false,
  isSubmitting = false,
}) => {
  const [isFormValid, setIsFormValid] = useState(false)
  const location = useLocation()
  const isTestMode =
    new URLSearchParams(location.search).get("test-data") === "1"

  const handleFormSubmit = (values, files = {}) => {
    console.log("[DEBUG_LOG] Container handleFormSubmit called with values")
    console.log("[DEBUG_LOG] Calling handleSaveApplyUser")
    handleSaveApplyUser(values, files)
  }

  const handleNextClick = (e) => {
    e.preventDefault()
    console.log("[DEBUG_LOG] Next button clicked, isFormValid:", isFormValid)
    try {
      // Always submit the form, regardless of whether it's valid or not
      // This will trigger the Formik handleSubmit function, which will mark all fields as touched
      // and show all validation errors if the form is invalid
      const form = document.getElementById("formikForm")
      console.log("[DEBUG_LOG] Form element found:", !!form)
      if (form) {
        console.log("[DEBUG_LOG] Dispatching submit event on form")
        form.dispatchEvent(
          new Event("submit", { cancelable: true, bubbles: true }),
        )
        console.log("[DEBUG_LOG] Submit event dispatched successfully")
      } else {
        console.error("[DEBUG_LOG] Form element with ID 'formikForm' not found")
        // Try to find the form by other means
        const forms = document.getElementsByTagName("form")
        console.log("[DEBUG_LOG] Number of forms found on page:", forms.length)
        if (forms.length > 0) {
          console.log("[DEBUG_LOG] First form ID:", forms[0].id)
        }
      }
    } catch (error) {
      console.error("[DEBUG_LOG] Error in handleNextClick:", error)
    }
  }

  const testData = isTestMode
    ? {
        companyName: "Test Company Inc",
        companyPhonenumber: "+1 (555) 123-4567",
        streetAddress: "123 Test Street",
        addressLine2: "Suite 100",
        stateRegion: "California",
        zipCode: "90001",
        country: "United States",
        website: "https://testcompany.com",
        industries: "Technology, Software Development",
        goodsServicesUploadOption: "text",
        services:
          "We provide comprehensive software development services including web applications, mobile apps, and cloud solutions.",
        goodsServicesUpload: false,
        certificationsUploadOption: "text",
        certifications: "NMSDC Certified, WBENC Certified",
        certificationsUpload: false,
        qualityCertifications: "ISO9001, TS16949",
        terms: "yes",
        terms1: "yes",
        customers: "1. Microsoft\n2. Google\n3. Amazon",
        revenueRange: "1m_5m",
        regionUS: true,
        regionCanada: true,
        regionEurope: false,
        regionAsiaPacific: true,
        regionLatinAmerica: false,
        regionMiddleEast: false,
        regionAfrica: false,
        additionalInfo:
          "Our company is committed to innovation and excellence in software development. We have been in business for over 10 years and have a team of 50+ developers.",
        preference1: true,
        preference2: false,
        preference3: false,
        preference4: false,
        preference5: false,
        preference6: false,
        preference7: false,
        preference8: false,
        preference9: true,
        preferenceNA: false,
      }
    : null

  return (
    <SignUpApplyContainer
      title="Membership Application"
      onBack={handleBack}
      onNext={handleNextClick}
      isButtonSubmit={true}
      withBackBtn={true}
      isNextDisabled={false}
      isSubmitting={isSubmitting}
    >
      <SignUpApplyStep2Form
        onSubmit={handleFormSubmit}
        onValidityChange={setIsFormValid}
        initialValues={isTestMode ? testData : isEditMode ? initialValues : {}}
        step1Data={step1Data}
        isEditMode={isEditMode}
      />
    </SignUpApplyContainer>
  )
}

SignUpApplyStep2Container.propTypes = {
  history: PropTypes.object,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  handleSaveApplyUser: PropTypes.func.isRequired,
  step1Data: PropTypes.object,
  initialValues: PropTypes.object,
  isEditMode: PropTypes.bool,
  isSubmitting: PropTypes.bool,
}

export default SignUpApplyStep2Container
